<template>
  <ion-page>
    <ion-content>
      <Stories
        :stories="items"
        :currentIndex="currentSlideIndex"
        :authuser="$store.state.authuser"
      />
    </ion-content>
  </ion-page>
</template>

<script>
import Stories from "./stories.vue";
import { IonContent, IonPage } from "@ionic/vue";
export default {
  components: { Stories, IonContent, IonPage },
  props: {
    //  authuser:{},
    stories: {},
  },
  computed: {
    authuser() {
      return this.$store.state.authuser;
    },
    estados() {
      return this.$store.getters.getStories;
    },
    currentSlideIndex() {
      return parseInt(this.$route.params.id);
    },
    items() {
      return this.estados.map((item, index) => {
        return {
          id: item.id,
          userid: item.user.id,
          username: item.user.username,
          picture: item.user.image,
          time: item.created_at,
          images: item.estados.map((item, index) => {
            return {
              id: item.id,
              story_id: item.story_id,
              url: item.image
                ? item.image.image
                : item.video
                ? item.video.video
                : item.tipo,

              type: item.image ? "image" : item.video ? "video" : "text",
              background: item.image
                ? "gradient-0"
                : item.video
                ? "gradient-0"
                : item.background,
              viewers: item.viewers,
              duration: item.video ? item.video.duration : 7000,
              attachment: item.video
                ? item.video.video
                : item.image
                ? item.image.image
                : "",
              text: item.tipo ? item.tipo : "",
              created_at: item.created_at,
            };
          }),
        };
      });
    },
  },
  methods: {
    demo() {
      alert("marked");
    },
  },
  data: () => ({}),
};
</script>
